import React,{lazy,Suspense} from 'react';
import {BrowserRouter as Router, Route } from 'react-router-dom';
import {AppFrame} from '../templates/AppFrame';
import LinearProgress from '@material-ui/core/LinearProgress';
import {CtaButton} from '../atoms/Button'
import {Footer} from '../molecules/Footer'
import {cvUrl,logoUrl,ctaText,links,copyRights} from '../../static/data'

const TopPage = lazy(() => import('./TopPage'));
const CompanyPage = lazy(() => import('./CompanyPage'));
const TokushoPage = lazy(() => import('./TokushoPage'));
const ThanksPage = lazy(() => import('./ThanksPage'));
const PrivacyPage = lazy(() => import('./PrivacyPage'));
const TermsPage = lazy(() => import('./TermsPage'));

const pages = [
    { path: '/', component: <TopPage/> ,cta:<CtaButton href={cvUrl} label="cta_button" >{ctaText}</CtaButton>},
    { path: '/company', component: <CompanyPage/> ,cta:null},
    { path: '/tokusho', component: <TokushoPage/> ,cta:null},
    { path: '/thanks', component: <ThanksPage/> ,cta:null},
    { path: '/privacy', component: <PrivacyPage/> ,cta:null},
    { path: '/terms', component: <TermsPage/> ,cta:null},
];

const Pages = ()=>{
    return(
      <Router>
     
        {pages.map((item,index) => (
          <Route
            key={index}
            exact
            path={item.path}
            component={() => 
            <Suspense fallback={<LinearProgress />}>
               <AppFrame cta={item.cta} logoUrl={logoUrl} >
                {item.component}
              <Footer links={links} copyRights={copyRights}/>
              </AppFrame>
            </Suspense>}
          />
        ))}
        
      </Router>
    )
  };
  export default Pages;
  